"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createNephrectomyOrGraftectomy = createNephrectomyOrGraftectomy;
const utils_1 = require("../../../events/utils");
const shared_1 = require("../../shared");
const queries_1 = require("../queries");
const nephrectomyOrGraftectomy_1 = require("../../../forms/ktx/transplantation-screening/medical-history/nephrectomyOrGraftectomy");
const messages = {
    title: {
        id: "ktx.dashboard.nephrectomy_or_graftectomy",
        defaultMessage: "Nephrectomia vagy Graftectomia"
    }
};
function createNephrectomyOrGraftectomy(intl, options) {
    const lists = createList(intl, options);
    const content = (0, shared_1.createGroupContent)(lists);
    return (0, shared_1.createGroup)(intl, { label: messages.title, content });
}
function createList({ formatMessageMap, formatDate }, { events }) {
    const graftectomyEvents = (0, utils_1.findEventsByQuery)(events, queries_1.medicalHistoryQueries.graftectomy);
    const nephrectomyEvents = (0, utils_1.findEventsByQuery)(events, queries_1.medicalHistoryQueries.nephrectomy);
    const relevantEvents = [...graftectomyEvents, ...nephrectomyEvents];
    const m = { ...nephrectomyOrGraftectomy_1.diseasesMessages, ...nephrectomyOrGraftectomy_1.hasDiseaseMessages };
    return relevantEvents
        .map(event => {
        const { timestamp, origin } = event;
        const formattedTimestamp = formatDate(timestamp, {
            year: "numeric",
            month: "numeric",
            day: "numeric"
        });
        const items = [];
        items.push({
            type: "list-item",
            value: formatMessageMap(m, event.value)
        });
        return {
            type: "list",
            attachments: (0, utils_1.mapEventsToAttachments)(event),
            timestamp: event.timestamp,
            label: formattedTimestamp,
            origin,
            items
        };
    })
        .sort(shared_1.compareByTimestamp);
}
